import { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { IonPageStratus } from 'commons/components';
import { useModal } from 'commons/hooks';
import { configurationsRoutes } from 'domains/Configurations';
import { DomainSoftBlock } from '../../components';
import { useGetDomainSoftBlockQuery } from '../../domainsApi';
import { useDomainSoftBlock } from '../../hooks';
import {
  trackingNotifyChangesClick,
  trackingRememberLaterClick,
  trackingSoftblockNameserverViewed,
} from '../../tracking';
import { DomainsCheckoutPage } from '../DomainsCheckoutPage';
import { DomainsLandingPage } from '../DomainsLandingPage';
import { DomainsListPage } from '../DomainsListPage';
import { ActionType } from '../DomainSoftBlockPage';
import { DomainsOrderDetailsPage } from '../DomainsOrderDetailsPage';

const PAGE_SOURCE = 'domain';

export function DomainsPageWithSoftBlock() {
  const { data } = useGetDomainSoftBlockQuery();
  const { shouldShowInDomainPage, dismissInDomainPage, notifyDomainUpdate } =
    useDomainSoftBlock();
  const [showNotificationModal, openNotificationModal, closeNotificationModal] =
    useModal();
  const [mode, setMode] = useState<ActionType>('cancel');

  const isErrorScreen = !!data?.error;

  useEffect(() => {
    if (data?.storeId) {
      trackingSoftblockNameserverViewed(
        data.storeId,
        PAGE_SOURCE,
        isErrorScreen,
      );
    }
    return () => {
      dismissInDomainPage(true);
    };
  }, [data?.storeId, dismissInDomainPage, isErrorScreen]);

  if (!shouldShowInDomainPage || !data)
    return (
      <Switch>
        <Route path={configurationsRoutes.domainsList} exact>
          <DomainsListPage />
        </Route>
        <Route path={configurationsRoutes.domains} exact>
          <DomainsLandingPage />
        </Route>
        <Route path={configurationsRoutes.domainsCheckout} exact>
          <DomainsCheckoutPage />
        </Route>
        <Route path={configurationsRoutes.domainsOrder} exact>
          <DomainsOrderDetailsPage />
        </Route>
        <Redirect to={configurationsRoutes.domains} />
      </Switch>
    );

  const handleConfirmAction = () => {
    closeNotificationModal();
    notifyDomainUpdate();
    trackingNotifyChangesClick(data.storeId, PAGE_SOURCE);
  };

  const handleCancel = () => {
    dismissInDomainPage(false);
    trackingRememberLaterClick(data.storeId, PAGE_SOURCE);
  };

  const handleConfirm = () => {
    openNotificationModal();
    setMode('confirm');
  };

  return (
    <IonPageStratus width="small">
      <DomainSoftBlock
        data={data}
        mode={mode}
        showNotificationModal={showNotificationModal}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        onConfirmAction={handleConfirmAction}
        source={PAGE_SOURCE}
      />
    </IonPageStratus>
  );
}
